// extracted by mini-css-extract-plugin
export default {"flagIcon":"YF75C"};